module.exports = __webpack_public_path__ + "static/dots-green-631c9ce70e25cc22bf7419f322785d84.svg";